import DropdownOption from '../dto/DropdownOption.interface'

// @ts-unexpect-error
const findElementInArray = (array: [DropdownOption], value: string): DropdownOption | undefined => {
    return array.find((element) => element.value === value);
}

export { findElementInArray }
